module.exports = __webpack_public_path__ + "static/media/devices-3d-v4.9cb13b2a.png";